import { render, staticRenderFns } from "./CtaActividadesBrightStarts.vue?vue&type=template&id=620f39e0"
import script from "./CtaActividadesBrightStarts.vue?vue&type=script&lang=js"
export * from "./CtaActividadesBrightStarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports